import _objectSpread from "/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["bsPrefix", "className", "as"];
import classNames from 'classnames';
import * as React from 'react';
import { useBootstrapPrefix } from './ThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
var DEVICE_SIZES = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
var Col = /*#__PURE__*/React.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      props = _objectWithoutProperties(_ref, _excluded);

  var prefix = useBootstrapPrefix(bsPrefix, 'col');
  var spans = [];
  var classes = [];
  DEVICE_SIZES.forEach(function (brkPoint) {
    var propValue = props[brkPoint];
    delete props[brkPoint];
    var span;
    var offset;
    var order;

    if (typeof propValue === 'object' && propValue != null) {
      var _propValue$span = propValue.span;
      span = _propValue$span === void 0 ? true : _propValue$span;
      offset = propValue.offset;
      order = propValue.order;
    } else {
      span = propValue;
    }

    var infix = brkPoint !== 'xs' ? "-".concat(brkPoint) : '';
    if (span) spans.push(span === true ? "".concat(prefix).concat(infix) : "".concat(prefix).concat(infix, "-").concat(span));
    if (order != null) classes.push("order".concat(infix, "-").concat(order));
    if (offset != null) classes.push("offset".concat(infix, "-").concat(offset));
  });

  if (!spans.length) {
    spans.push(prefix); // plain 'col'
  }

  return /*#__PURE__*/_jsx(Component, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    className: classNames.apply(void 0, [className].concat(spans, classes))
  }));
});
Col.displayName = 'Col';
export default Col;